/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "sign-out-05764ed6--sprite",
  "use": "sign-out-05764ed6--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"sign-out-05764ed6--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-849.248 215.777)\"><path d=\"M874.957-197.982a1.707,1.707,0,0,0-.15-.13.413.413,0,0,0,.052.042c.035.029.07.057.1.088l-.05-.05a.154.154,0,0,0-.02-.016l-2.934-2.934a1.015,1.015,0,0,0-.109-.109,1,1,0,0,0-1.41.109,1,1,0,0,0,.109,1.41l1.29,1.29h-4.59a1,1,0,0,0-1,1,1,1,0,0,0,1,1h4.6l-1.3,1.3a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l3-3a.976.976,0,0,0,.21-.32.314.314,0,0,0,.04-.14A.948.948,0,0,0,874.957-197.982Z\" fill=\"currentColor\" /><path d=\"M867.248-193.778a1,1,0,0,0-1,1v2h-4v-13h4v2a1,1,0,0,0,1,1,1,1,0,0,0,1-1v-2a2,2,0,0,0-2-2h-4a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2v-2A1,1,0,0,0,867.248-193.778Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
